// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';

export const InfluencerPicksWrapper = styled.div`
  ${(props) =>
    props.isInfluencerPicksEnabled
      ? `margin-bottom: 8px;
    min-height: 16px;
    @media ${props.theme.mediaQuery.medium} {
      min-height: 19px;
    }
    @media ${props.theme.mediaQuery.large} {
     margin-bottom: 12px;
    }
    `
      : ''}
`;

export const PriceSection = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
`;

export const ATBIcon = styled.button`
  padding: 0;
  border: 0;
  position: relative;
  box-sizing: border-box;
  cursor: pointer;

  &,
  .atb-icon-image {
    width: 32px;
    height: 32px;
    border-radius: 50%;

    @media ${(props) => props.theme.mediaQuery.large} {
      width: 44px;
      height: 44px;
    }
  }

  .atb-icon-image {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const Title = styled(BodyCopy)`
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: block;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media ${(props) => props.theme.mediaQuery.large} {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
  }
`;

export const ItemsInBagWrapper = styled.div`
  position: absolute;
  top: 12px;
  left: 12px;
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: 0;
  padding-top: ${Math.ceil((328 / 264) * 100)}%;
  position: relative;
  overflow: hidden;
  margin-bottom: 8px;
  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    margin-bottom: 12px;
  }
`;

export default css`
  .color-swatches-wrapper,
  .promotions-container {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
  }

  .title-wrapper {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    .title-wrapper {
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    }
  }
`;
